import { ComponentProps } from 'react';
import {
  defineMessages,
  FormattedMessage,
  MessageDescriptor,
} from 'react-intl';

import { EmployerPurchaseProductType } from '../../common/interfaces/entities';
import { TimePeriodUnit } from '../../common/interfaces/time-period-unit';
import { CreditProductPackageTag } from './types';

export const GraphqlErrorCodes = {
  OPERATION_NOT_ALLOWED: 'OPERATION_NOT_ALLOWED',
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  JOB_ALREADY_BOOSTED: 'JOB_ALREADY_BOOSTED',
  JOB_NO_LONGER_SUPPORT: 'JOB_NO_LONGER_SUPPORT',
  JOB_ALREADY_USING_THE_PRODUCT: 'JOB_ALREADY_USING_THE_PRODUCT',
  CREDIT_PURCHASE_ORDER_CANCELLED: 'CREDIT_PURCHASE_ORDER_CANCELLED',
  CREDIT_PURCHASE_ORDER_EXPIRED: 'CREDIT_PURCHASE_ORDER_EXPIRED',
  CONFLICT_WITH_ACTIVE_SUBSCRIPTION: 'CONFLICT_WITH_ACTIVE_SUBSCRIPTION',
} as const;

export const TrackingProductNames = {
  topUpCredits: 'top_up_credits',
  hotJob: 'hotjob',
  recommendedTalent: 'recommended_talent',
  vipMembership: 'vip_membership',
  talentSearch: 'talent_search',
  premium_plan: 'subscription_plan',
  contact_packs: 'contact_packs',
} as const;

export type TrackingProductNames =
  (typeof TrackingProductNames)[keyof typeof TrackingProductNames];

export const DEFAULT_VIP_MEMBERSHIP_STARTING_PRICE = 180;

export const CreditProductStartingPrices: Partial<
  Record<EmployerPurchaseProductType, number>
> = {
  [EmployerPurchaseProductType.HOT_JOB]: 220,
  [EmployerPurchaseProductType.RECOMMENDED_TALENT_CHAT]: 60,
  [EmployerPurchaseProductType.TALENT_SEARCH]: 150,
  [EmployerPurchaseProductType.SHORTLIST]: 50,
  [EmployerPurchaseProductType.VIP_MEMBERSHIP]:
    DEFAULT_VIP_MEMBERSHIP_STARTING_PRICE,
};

export const timePeriodUnitToText: Record<TimePeriodUnit, MessageDescriptor> =
  defineMessages({
    [TimePeriodUnit.days]: {
      id: 'text-days-count',
      defaultMessage: '{count, plural,  =1 {day} other {days}}',
    },
    [TimePeriodUnit.months]: {
      id: 'text-months-count',
      defaultMessage: '{count, plural, =1 {month} other {months}}',
    },
    [TimePeriodUnit.years]: {
      id: 'text-years-count',
      defaultMessage: '{count, plural, =1 {year} other {years}}',
    },
  });

export const CreditProductPackageTagToText: Record<
  Exclude<CreditProductPackageTag, 'POPULAR'>,
  ComponentProps<typeof FormattedMessage>
> = {
  [CreditProductPackageTag.THIRTY_THREE_OFF]: {
    id: 'text-count-percent-off',
    defaultMessage: '{count}% OFF',
    values: { count: 33 },
  },
  [CreditProductPackageTag.TWENTY_FIVE_OFF]: {
    id: 'text-count-percent-off',
    defaultMessage: '{count}% OFF',
    values: { count: 25 },
  },
  [CreditProductPackageTag.TWENTY_OFF]: {
    id: 'text-count-percent-off',
    defaultMessage: '{count}% OFF',
    values: { count: 20 },
  },
} as const;
